import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'universal-scripts';

export const useErrorToast = () => {
	const dispatch = useAppDispatch();
	const errorText = useAppSelector((s) => s.errorToast);

	const closeError = useCallback(() => dispatch({ type: 'error/hide' }), [dispatch]);

	useEffect(() => {
		const id = setTimeout(closeError, 3000);
		return () => clearTimeout(id);
	}, [errorText, closeError]);

	return {
		errorText,
		closeError
	};
};
